





















import {Component, Prop, Ref, Vue} from 'vue-property-decorator';
import {Location} from "vue-router"

/**
 * @status stable
 * @published 4.0.0
 * @changelog 4.4.4 Published.
 * @changelog 4.5.6 Made inline-block.
 */
@Component
export default class JdsPageBackLink extends Vue {

    @Prop() to!: Location;

    @Ref() linkEl!: HTMLElement;
    hover = false;

    startAnimation() {
        this.linkEl.classList.add('jdsc-page-back-link--animate');
        this.hover = true;
    }

    animationTicker() {
        if (!this.hover) {
            this.linkEl.classList.remove('jdsc-page-back-link--animate');
        }
    }
}
